import { Box, Flex } from 'components/elements'
import { Modal } from 'components/modal'
import { POLY_EXPLORER_URL } from 'configs/constants'
import { BoxBorder, CopiedBgCSS, InlineCSS, TextOverFlowCSS } from './style'
import { Button } from 'components/button'
import CopyToClipboard from 'react-copy-to-clipboard'
import { ViewOnChainDataBasedOnPrimaryService } from 'utils/function'
import { useState } from 'react'

type ViewExploreModalProp = {
  showOnChain: boolean
  setShowOnChain: (value: boolean) => void
  isLoading: boolean
  threatChainTransactionData: {
    trx_hash: string
    dlt_hash: string
    id: string
  }
  incidentListRow: Record<string, any>
  evaluationStatus: string
}
const ViewExploreModal = (props: ViewExploreModalProp) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    setCopied(true)

    setTimeout(() => {
      setCopied(false)
    }, 2500)
  }
  const { showOnChain, setShowOnChain, isLoading, threatChainTransactionData, incidentListRow, evaluationStatus } = props
  return (
    <Modal
      active={showOnChain}
      hideModal={() => setShowOnChain(false)}
      isLoading={isLoading}
      title={'Transaction information'}
      acceptText={'View on explorer'}
      buttonAsAnchor={true}
      hrefValue={`${POLY_EXPLORER_URL}${threatChainTransactionData?.trx_hash}`}
      children={
        <Box>
          <Box as="h4">
            Blockchain :{' '}
            <Box as="p" css={InlineCSS}>
              Polygon
            </Box>
          </Box>
          <Box as="h4" css={{ display: 'flex', gap: 5 }}>
            Transaction hash :{' '}
          </Box>
          <Flex css={{ columnGap: '1rem', pb: '1rem' }}>
            <BoxBorder css={{ width: 'calc(100% - 154px)' }}>
              {copied ? (
                <Box as="h4" css={CopiedBgCSS}>
                  Hash Copied!
                </Box>
              ) : null}
              <Box as="p" css={TextOverFlowCSS}>
                {threatChainTransactionData?.trx_hash}
              </Box>
            </BoxBorder>
            <Button css={{ minWidth: 100 }} id="copy_text_button">
              <CopyToClipboard text={threatChainTransactionData?.trx_hash} onCopy={handleCopy}>
                <Box as="p" css={{ m: 0 }}>
                  Copy Text
                </Box>
              </CopyToClipboard>
            </Button>
          </Flex>
          <Box as="h4">
            DLT Hash :{' '}
            <Box as="p" css={{ ...InlineCSS, wordBreak: 'break-all' }}>
              {threatChainTransactionData?.dlt_hash}
            </Box>
          </Box>
          <Box as="h4">
            Claim Id :{' '}
            <Box as="p" css={InlineCSS}>
              {threatChainTransactionData?.id}
            </Box>
          </Box>

          <RenderViewOnChainMapping serviceName={evaluationStatus} incidentListRow={incidentListRow} />
        </Box>
      }
    ></Modal>
  )
}
const RenderViewOnChainMapping = ({ serviceName, incidentListRow }: { serviceName: string; incidentListRow: Record<string, any> }) => {
  const contractData = ViewOnChainDataBasedOnPrimaryService(serviceName, incidentListRow)

  return (
    <Box>
      {contractData.map((data, index) => (
        <Box key={index} as="h4">
          {data.key}:{' '}
          <Box as="p" css={InlineCSS}>
            {data.value}
          </Box>
        </Box>
      ))}
    </Box>
  )
}

export default ViewExploreModal
